export const TOKEN_AUTH_USERNAME = 'innjwtclientid';
export const TOKEN_AUTH_PASSWORD = 'INN8kmzuPzl200';
export const TOKEN_NAME = 'inn_token';
